import React from 'react';
import ButtonContainer from '@containers/ssap/ButtonContainer';

// Components

/**
 * This Component creates container for all bottom-page buttons (usually: 'Back', 'Save' and 'Continue')
 */
const Controls = props => {

    const {
        disabledUi
    } = props;

    const getButton = type => {
        return (
            <ButtonContainer
                { ...{
                    ...props,
                    type,
                    isDisabled: disabledUi.buttonsDisabled.includes(type)
                } }
            />
        );
    };

    return (
        <div className="controls-container">
            <div className="grid-row controls">
                <div className="tablet:grid-col-6">
                    { getButton('leftButton') }
                </div>
                <div className="tablet:grid-col-6 buttons-group txt-right">
                    { getButton('middleButton') }
                    { getButton('rightButton') }
                </div>
            </div>
        </div>
    );
};


export default Controls;
